import React, {useRef} from "react";
import {ButtonIcon, Loading, Modal, Pagination, Search, Select, TextSearchMarker, useList,} from "@vokymlak/kabinet-ui";
import {ROOT_URL} from "../../../config/url";
import moment from "moment/moment";

function ModalCowParentSelect(props) {
  const {
    list: [list, count, setList],
    update: [isUpdateList, setIsUpdateList, updateList],
    page: [pageNumber, setPageNumber, pageLimit, setPageLimit],
    search: [searchQuery, setSearchQuery],
  } = useList({
    apiUrl: "/api/cows",
    rootUrl: ROOT_URL,
    isPagination: true,
    paginationLimit: 25,
    isSearch: true,
  });

  const changeAdd = (item) => {
    props.successfulRequest(item);
    props.handleClose();
  };

  const inputSearchText = useRef(null);

  function onChangeSearchText() {
    setSearchQuery(inputSearchText.current.value);
  }

  const changePage = (data) => {
    if (pageNumber !== data.currentPage) {
      setPageNumber(data.currentPage);
    }
  };

  return (
    !!list && (
      <Modal handleClose={() => props.handleClose()} contentStyle={{
        width: 480
      }}>
        <form className="Form" onSubmit={(event) => changeAdd(event)}>
          <div className="Form__title">
            Выбор&nbsp;
            {!!props.typeTag && props.typeTag === "MALE" && "папы"}
            {!!props.typeTag && props.typeTag === "FEMALE" && "мамы"}
            <div className="Text__signature">КРС</div>
          </div>

          <div className="Form__field">
            <div className="Page__title">
              <div
                className="Title__text"
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: 21,
                  fontWeight: 700,
                }}
              >
                КРС
                {!!list && (
                  <span style={{fontSize: 12, opacity: 0.75, marginLeft: 6}}>
                  ({count})
                </span>
                )}
                <span style={{width: 140, marginLeft: 16}}>
                <Search
                  reference={inputSearchText}
                  type="text"
                  label={"Поиск"}
                  isFixed={true}
                  onChange={() => onChangeSearchText()}
                />
              </span>
              </div>

              <div className="Title__settings">
                <ButtonIcon
                  tooltipText={"Обновить"}
                  iconName={"custom-change-circle"}
                  iconColor={"#20202075"}
                  size={28}
                  style={{marginLeft: 8}}
                  onClick={() => (setList(null), setIsUpdateList(!isUpdateList))}
                />

                {!!count && !!pageLimit && (
                  <div
                    style={{
                      marginLeft: 12,
                      width: 64,
                    }}
                  >
                    <Select
                      isFixed={true}
                      isDefaultOption={false}
                      value={pageLimit}
                      options={[
                        {
                          value: 10,
                          title: 10,
                        },
                        {
                          value: 25,
                          title: 25,
                        },
                        {
                          value: 50,
                          title: 50,
                        },
                        {
                          value: 75,
                          title: 75,
                        },
                        {
                          value: 100,
                          title: 100,
                        },
                      ]}
                      label="Лимит"
                      onChange={(event) => setPageLimit(Number(event.target.value))}
                    />
                  </div>
                )}

                {!!count && count > pageLimit && (
                  <div style={{marginLeft: 8}}>
                    <Pagination
                      totalRecords={count}
                      pageLimit={pageLimit}
                      currentPage={pageNumber}
                      onPageChanged={(data) => changePage(data)}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          <hr className={"Page__hr"} style={{marginBottom: 24}}/>

          <div className="Form__field Form__field_last"
               style={{
                 height: 360,
                 overflowY: "auto"
               }}>
            {!list && (
              <div className={"Page__loader"}>
                <Loading/>
              </div>
            )}

            {list.map((item, index) => (
              <div key={"item_" + index} onClick={() => changeAdd(item)} style={{
                padding: "4px 8px",
                border: "1px solid #dbdbdb",
                cursor: "pointer",
                marginBottom: 6,
                borderRadius: 5,
              }}>
                <div
                  style={{
                    fontSize: 19,
                    fontWeight: 700,
                    width: "100%",
                  }}
                >
                  {!!item.name && (
                    <TextSearchMarker
                      text={item.name}
                      search={searchQuery}
                    />)}
                  <span style={{
                    fontSize: 12,
                    fontWeight: 400,
                    marginLeft: 4
                  }}>
                          (<TextSearchMarker
                    text={item.id}
                    search={searchQuery}
                  />)
                        </span>
                  {!!item.birthdate && (
                    <div style={{
                      fontSize: 12,
                      fontWeight: 400,
                    }}>
                      Дата&nbsp;рождения:&nbsp;{(!!item.birthdate && moment(item.birthdate.substring(0, 19)).format("DD.MM.YYYY")) || "-"}
                    </div>
                  )}
                  {!!item.chip_code && (
                    <div style={{
                      fontSize: 12,
                      fontWeight: 400,
                    }}>
                      Код&nbsp;с&nbsp;чипа:&nbsp;
                      <TextSearchMarker
                        text={item.chip_code}
                        search={searchQuery}
                      />
                    </div>
                  )}
                  {!!item.unm_code && (
                    <div style={{
                      fontSize: 12,
                      fontWeight: 400,
                    }}>
                      УНСМ&nbsp;номер:&nbsp;
                      <TextSearchMarker
                        text={item.unm_code}
                        search={searchQuery}
                      />
                    </div>
                  )}
                  {!!item.note && (
                    <div style={{
                      fontSize: 12,
                      fontWeight: 400,
                    }}>
                      <TextSearchMarker
                        text={item.note}
                        search={searchQuery}
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {!!props.item && (
            <div className="Form__actions Form__actions_center">
              <div
                className="Action__link Action__link_red"
                onClick={() => (props.successfulRequest(null), props.handleClose())}
              >
                Удалить
              </div>
            </div>
          )}

          <div className="Form__actions Form__actions_center">
            <div className="Action__link" onClick={() => props.handleClose()}>
              Отмена
            </div>
          </div>
        </form>
      </Modal>
    )
  );
}

export default ModalCowParentSelect;
